import type { TFunction } from "i18next";
import { type EventListItemDto, RegulationBucket } from "../../autogen/bff-api";
import { regulationLabel } from "../../common/procurement/regulationLabel";
import { getProcedureLabel } from "./portal/utils/displayFormatters";

type Classified = Pick<EventListItemDto, "procedureType" | "regulation" | "namesNoProcedure">;

const FOA_PARTS: ReadonlySet<RegulationBucket> = new Set([
  RegulationBucket.FoaPartI,
  RegulationBucket.FoaPartIi,
  RegulationBucket.FoaPartIii,
  RegulationBucket.FoaPartIv,
]);

export const procedureText = (event: Classified, t: TFunction): string | null => {
  if (event.procedureType) {
    return getProcedureLabel(event.procedureType, t, { namesNoProcedure: event.namesNoProcedure });
  }
  return event.regulation === RegulationBucket.NotClassified ? t("Not classified") : null;
};

export const regulationText = (event: Classified, t: TFunction): string | null => {
  const bucket = event.regulation;
  if (!bucket || bucket === RegulationBucket.Private) return null;
  return regulationBucketText(bucket, t);
};

export const regulationBucketText = (bucket: RegulationBucket, t: TFunction): string => {
  const label = regulationLabel(t, bucket);
  return FOA_PARTS.has(bucket) ? t("FOA regulation part {{part}}", { part: label }) : label;
};
